import { useCallback, useLayoutEffect, useState } from 'react';
import useWindowEvent from './useWindowEvent';

const eventListenerOptions = {
    passive: true,
};

const getSize = (ref) => ({
    width: ref ? ref?.current?.offsetWidth : window.innerWidth,
    height: ref ? ref?.current?.offsetHeight : window.innerHeight,
});

const useWindowSize = (ref) => {
    const [windowSize, setWindowSize] = useState(() =>
        typeof window !== 'undefined' ? getSize(ref) : { width: 0, height: 0 },
    );

    const setSize = useCallback(() => {
        setWindowSize(getSize(ref));
    }, [ref]);

    // Ensure we measure once before paint → avoids flicker
    useLayoutEffect(() => {
        setSize();
    }, [setSize]);

    useWindowEvent('resize', setSize, eventListenerOptions);
    useWindowEvent('orientationchange', setSize, eventListenerOptions);

    return windowSize;
};

export default useWindowSize;
